import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n/translations";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { BrandMarquee } from "@/components/BrandMarquee";
import { SuryaGhar } from "@/components/SuryaGhar";
import { Services } from "@/components/Services";
import { ServicePartner } from "@/components/ServicePartner";
import { Gallery } from "@/components/Gallery";
import { Equipment } from "@/components/Equipment";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import { FloatingWidgets } from "@/components/Chatbot";
import Admin from "@/pages/Admin";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <BrandMarquee />
      <Services />
      <ServicePartner />
      <SuryaGhar />
      <Gallery />
      <Equipment />
      <LeadForm />
    </main>
    <Footer />
    <FloatingWidgets />
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (a) {
        const el = document.querySelector(a.getAttribute("href"));
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -70 });
        }
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-navy-950 font-body text-slate-200">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="light" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
